import logoUrl from '@/assets/brand/club29-logo.jpg';
import { cn } from '@/utils/cn';

import styles from './BrandLogo.module.css';

export interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  /** Line under the wordmark, e.g. "GYM · ADMIN". Leave out for the badge alone. */
  caption?: string;
  /** Show the badge only (no wordmark). */
  badgeOnly?: boolean;
  /** Light text, for the logo on its own near-black panel (where the badge looks its best). */
  onDark?: boolean;
  className?: string | undefined;
}

/** The Club29 Gym badge, with the italic wordmark beside it. */
export function BrandLogo({
  size = 'md',
  caption,
  badgeOnly = false,
  onDark = false,
  className,
}: BrandLogoProps) {
  return (
    <span className={cn(styles.logo, styles[size], onDark && styles.onDark, className)}>
      <img src={logoUrl} alt="Club29 Gym" className={styles.badge} />
      {!badgeOnly && (
        <span className={styles.text} aria-hidden="true">
          <span className={styles.wordmark}>
            CLUB<span className={styles.accent}>29</span>
          </span>
          {caption && <span className={styles.caption}>{caption}</span>}
        </span>
      )}
    </span>
  );
}
